import { render } from "./GlobalModal.vue?vue&type=template&id=0252e70b"
import script from "./GlobalModal.vue?vue&type=script&lang=js"
export * from "./GlobalModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/System/Compenents/Modal/GlobalModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0252e70b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0252e70b', __exports__)) {
    api.reload('0252e70b', __exports__)
  }
  
  module.hot.accept("./GlobalModal.vue?vue&type=template&id=0252e70b", () => {
    api.rerender('0252e70b', render)
  })

}


export default __exports__